import { Controller } from "@hotwired/stimulus"

// Renders a live preview as soon as a file is selected, so the user can SEE
// that their selection registered (instead of guessing whether the click
// silently failed). Used by avatar + cover_photo uploads on the seller store page.
export default class extends Controller {
  static targets = ["input", "preview", "placeholder", "selectedHint"]

  change() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const dataUrl = e.target.result

      if (this.hasPreviewTarget) {
        this.previewTarget.src = dataUrl
        this.previewTarget.classList.remove("hidden")
      }
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.add("hidden")
      }
      if (this.hasSelectedHintTarget) {
        this.selectedHintTarget.classList.remove("hidden")
        this.selectedHintTarget.textContent =
          this.selectedHintTarget.dataset.template?.replace("%{name}", file.name) ||
          `Selected: ${file.name}`
      }
    }
    reader.readAsDataURL(file)
  }
}
